import {ScreenshotType} from "./types";

export const CONFIG = {
    enabledScreenShotTypes: [ScreenshotType.Browser, ScreenshotType.Device, ScreenshotType.None],
    maxCanvasWidth: 2300,
    maxCanvasHeight: 2300,
    minCanvasHeight: 500,
    minCanvasWidth: 500,
}